module.exports = __webpack_public_path__ + "img/instagram-white.fde360b2.svg";